import { render, staticRenderFns } from "./EditSettlement.vue?vue&type=template&id=3a04527a&scoped=true"
import script from "./EditSettlement.vue?vue&type=script&lang=js"
export * from "./EditSettlement.vue?vue&type=script&lang=js"
import style0 from "./EditSettlement.vue?vue&type=style&index=0&id=3a04527a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a04527a",
  null
  
)

export default component.exports